import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {GET_VOTES, queryOptions} from './votes-graphql';
import {graphql} from 'react-apollo';
import {withAuth} from '../../components/auth';
import {withTranslationsAsProps} from '../../components/translations';
import {withUser} from '../user/user';
import Voters from './voters';

// using the unwrapped versions of these components, since
// the Votes component is serving as the interface currently.
import {mapStateToProps, VoteButton} from './vote-button';
import {VoteCount} from './vote-count';

import './votes.less';

export function Votes({
    className,
    data: {unitVotes, loading},
    endDate,
    langVote,
    langVoted,
    langVotes,
    listingId,
    locale,
    showLabel,
    showVoters,
    startDate,
    sm,
    tripBoardUuid,
    user,
    useSmallButton = false,
}) {
    if (loading || !unitVotes) {
        return <div className={`votes ${className}`}/>;
    }

    const {totalVotes = 0, votes = {}} = unitVotes || {};
    const myVote = unitVotes.myVote || {};
    const {profile} = user;
    const role = user && user.role && user.role.type || '';
    return (
        <div className={`votes ${className}`}>
            <VoteButton
                {...myVote}
                endDate={endDate}
                langVote={langVote}
                langVoted={langVoted}
                locale={locale}
                listingId={listingId}
                showLabel={showLabel}
                startDate={startDate}
                tripBoardUuid={tripBoardUuid}
                voter={profile}
                role={role}
                isSmall={useSmallButton}
            />
            <div className="votes__voters-vote-count">
                {showVoters &&
                    <Voters
                        listingId={listingId}
                        tripBoardUuid={tripBoardUuid}
                        votes={votes}
                    />
                }
                <VoteCount
                    langVotes={langVotes}
                    locale={locale}
                    sm={sm}
                    totalVotes={totalVotes}
                />
            </div>
        </div>
    );
}

Votes.defaultProps = {
    className: '',
    data: {},
    locale: 'en_US',
    showLabel: false,
    showVoters: false,
    sm: false,
    user: {}
};

export default compose(
    withAuth,
    withUser,
    connect(mapStateToProps),
    graphql(GET_VOTES, {options: queryOptions}),
    withTranslationsAsProps({
        'tripboards.vote.tooltip': 'langVote',
        'tripboards.voted.tooltip': 'langVoted',
        'tripboards.votes': 'langVotes'
    })
)(Votes);



// WEBPACK FOOTER //
// ./src/universal/tripboard/votes/votes.js